import { render, staticRenderFns } from "./NotificationCount.vue?vue&type=template&id=b3a0608e&scoped=true"
import script from "./NotificationCount.vue?vue&type=script&lang=ts"
export * from "./NotificationCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a0608e",
  null
  
)

export default component.exports